import React from 'react';
import { Route } from 'react-router-dom';
import ConfigIndex from './ConfigIndex';
import ConfigPage from './ConfigPage';
import Auth from '../../services/AuthService';
import FileNotFound from '../FileNotFound';

const ConfigRouter = () => {
  if (!Auth.isDsiSupport()) {
    // dsisupport only for now
    return <FileNotFound />;
  }

  return (
    <>
      <Route exact path="/UCG1/:name?" component={ConfigPage} />
      <Route exact path="/UCG0" component={ConfigIndex} />
    </>
  );
};

export default ConfigRouter;
